var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({class:{'error-highlight': _vm.errorHighlight},attrs:{"id":_vm.id,"type":"number","readonly":_vm.readonly,"label":_vm.label,"outlined":""},on:{"input":_vm.onInput},model:{value:(_vm.value),callback:function ($$v) {_vm.value=_vm._n($$v)},expression:"value"}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }